(function (global) {
  'use strict';

  // Rute-key -> URL-sti. Hver arbeidsflate far sin egen adresse under samme domene,
  // slik at den kan bokmerkes, deles og apnes i nytt vindu med hoyreklikk.
  //
  // Stiene er stabile norske slugs og skal IKKE oversettes: UI-sprak er per bruker
  // (`preferences.locale`), mens en delt lenke ma peke pa samme side uansett hvilket
  // sprak mottakeren har valgt. Bytt heller ikke en eksisterende sti uten grunn —
  // da rakner lagrede bokmerker.
  const ROUTE_PATHS = {
    hjem: '/',
    regnskapsforer: '/byra',
    superplumma: '/ai/superplumma',
    aiautopilot: '/ai/regnskapsforer',
    aiinnsikt: '/ai/radgiver',

    faktura: '/salg/nytt-salg',
    fakturaliste: '/salg/fakturaer',
    dagsoppgjor: '/salg/dagsoppgjor',
    annetsalg: '/salg/annet-salg',
    kunder: '/salg/kunder',
    produkter: '/salg/produkter',
    prosjekter: '/salg/prosjekter',
    abonnement: '/salg/avtaler',

    kjopsoversikt: '/kjop/oversikt',
    nyttkjop: '/kjop/nytt-kjop',
    fripostering: '/kjop/fri-postering',
    leverandorer: '/kjop/leverandorer',
    eiendeler: '/kjop/eiendeler',
    investeringer: '/kjop/investeringer',
    varelager: '/kjop/varelager',
    innboks: '/kjop/innboks',
    dokumentasjon: '/kjop/dokumentasjon',

    resultatregnskap: '/rapporter/resultatregnskap',
    saldobalanse: '/rapporter/saldobalanse',
    budsjett: '/rapporter/budsjett',

    innsendinger: '/innleveringer/mva-melding',
    skattemelding: '/innleveringer/skattemelding',
    arsavslutning: '/innleveringer/arsavslutning',
    arsregnskap: '/innleveringer/arsregnskap',
    'arsavslutning-kontoplan': '/innleveringer/arsavslutning/kontoplan',
    'arsavslutning-aksjekapital': '/innleveringer/arsavslutning/aksjekapital',
    'arsavslutning-kontanter': '/innleveringer/arsavslutning/kontanter',
    'arsavslutning-mva-kontoer': '/innleveringer/arsavslutning/mva-kontoer',
    'arsavslutning-pensjon': '/innleveringer/arsavslutning/pensjon',
    'arsavslutning-kjop': '/innleveringer/arsavslutning/kjop',
    'arsavslutning-salg': '/innleveringer/arsavslutning/salg',
    'arsavslutning-varelager': '/innleveringer/arsavslutning/varelager',
    'arsavslutning-periodiseringer': '/innleveringer/arsavslutning/periodiseringer',
    'arsavslutning-leverandorgjeld': '/innleveringer/arsavslutning/leverandorgjeld',
    'arsavslutning-kundefordringer': '/innleveringer/arsavslutning/kundefordringer',
    'arsavslutning-eiendeler': '/innleveringer/arsavslutning/eiendeler',
    'arsavslutning-lonn': '/innleveringer/arsavslutning/lonn',
    'arsavslutning-egenkapital': '/innleveringer/arsavslutning/egenkapital',
    'arsavslutning-sluttkontroll': '/innleveringer/arsavslutning/sluttkontroll',

    lonn: '/ansatte/lonn',
    kjorebok: '/ansatte/kjorebok',

    allebilag: '/annet/alle-bilag',
    transaksjon: '/annet/transaksjon',
    bank: '/annet/bank',

    minside: '/ovrig/min-side',
    aktivitetslogg: '/ovrig/aktivitetslogg',
    support: '/ovrig/support',
    innstillinger: '/ovrig/innstillinger',

    ansattportal: '/ansattportal',
    privatokonomi: '/privatokonomi',
  };

  // Undersider som er egne arbeidsflater far et eget sti-segment, slik at de kan
  // apnes i nytt vindu hver for seg. Regelen er: STIEN sier hvilken side du er pa,
  // QUERY sier hvilken kontekst (foretak). Nokkelen er sidens interne verdi
  // (`PAY_PAGES[].value`, `SETTINGS_TABS[].value`), verdien er slugen i adressen.
  const SUBPAGE_PATHS = {
    allebilag: {
      bilag: 'bilag',
      detaljer: 'detaljer',
      hovedbok: 'hovedbok',
    },
    // Byraaflaten er et eget skall med egne undersider, slik at en fane kan
    // bokmerkes og apnes i nytt vindu som resten av appen.
    regnskapsforer: {
      klientoversikt: 'klientoversikt',
      klienter: 'klienter',
      avstemming: 'avstemming',
      kontroll: 'kontroll',
      teamchat: 'teamchat',
      medarbeidere: 'medarbeidere',
      minside: 'min-side',
    },
    lonn: {
      employees: 'ansatte',
      payment: 'lonnsutbetaling',
      tax: 'arbeidsgiveravgift',
      pension: 'pensjon',
      fixed: 'faste-lonnslinjer',
      travel: 'reiser-og-utlegg',
      overview: 'lonnsoversikt',
      holiday: 'feriepenger',
      settings: 'lonnsinnstillinger',
      paytypes: 'lonnstyper',
    },
    // Tickets is the default page and keeps the bare path, so support-reply email
    // links (`/ovrig/support?sak=PLM-n`) keep working unchanged.
    support: {
      tickets: '',
      articles: 'artikler',
    },
    innstillinger: {
      foretak: 'foretak',
      profil: 'profil',
      tilgang: 'tilgang',
      preferanser: 'preferanser',
      regnskap: 'regnskap',
      bank: 'bank',
      investeringer: 'investeringer',
      data: 'data',
      dokumenter: 'dokumenter',
      integrasjoner: 'integrasjoner',
      abonnement: 'abonnement',
    },
  };

  // Foretaket henger pa som query. En delt lenke peker da bade pa siden og pa
  // foretaket, og to vinduer kan sta i hvert sitt foretak samtidig.
  const BUSINESS_PARAM = 'f';
  const ACTION_APPROVAL_BUSINESS_PARAM = 'approvalBusiness';

  const PATH_ROUTES = Object.keys(ROUTE_PATHS).reduce((acc, route) => {
    acc[ROUTE_PATHS[route]] = route;
    return acc;
  }, {});

  const SUBPAGE_ROUTES = Object.keys(SUBPAGE_PATHS).reduce((acc, route) => {
    acc[route] = Object.keys(SUBPAGE_PATHS[route]).reduce((slugs, subPage) => {
      // An empty slug is the default page; it resolves through the bare path.
      if (SUBPAGE_PATHS[route][subPage]) slugs[SUBPAGE_PATHS[route][subPage]] = subPage;
      return slugs;
    }, {});
    return acc;
  }, {});

  // Sammenligningsformen: uten query/hash, uten etterslepende skratrek, sma bokstaver.
  const normalizePath = (pathname) => {
    let path = String(pathname == null ? '/' : pathname);
    path = path.split('?')[0].split('#')[0];
    try { path = decodeURI(path); } catch (error) { /* ugyldig %-sekvens: bruk rastien */ }
    if (!path.startsWith('/')) path = '/' + path;
    path = path.replace(/\/+$/, '');
    return (path || '/').toLowerCase();
  };

  const pathForRoute = (route, subPage) => {
    const base = ROUTE_PATHS[route];
    if (!base) return null;
    const slug = subPage ? (SUBPAGE_PATHS[route] || {})[subPage] : '';
    return slug ? base + '/' + slug : base;
  };

  // null betyr "ikke en app-rute" — bade for ukjente stier og for reserverte stier
  // som `/invoice/view/...`, som eies av den offentlige fakturavisningen.
  const resolvePath = (pathname) => {
    const path = normalizePath(pathname);
    const route = PATH_ROUTES[path];
    if (route) return { route, subPage: '' };
    // Undersiden ligger i siste segment. Bare ett niva — ingen rute har undersider
    // av undersider.
    const cut = path.lastIndexOf('/');
    if (cut < 1) return null;
    const parentRoute = PATH_ROUTES[path.slice(0, cut)];
    const subPage = parentRoute ? (SUBPAGE_ROUTES[parentRoute] || {})[path.slice(cut + 1)] : '';
    return subPage ? { route: parentRoute, subPage } : null;
  };

  const routeForPath = (pathname) => (resolvePath(pathname) || {}).route || null;

  const subPageForPath = (pathname) => (resolvePath(pathname) || {}).subPage || '';

  const subPagesForRoute = (route) => SUBPAGE_PATHS[route] || null;

  const businessFromSearch = (search) => {
    try {
      const params = new URLSearchParams(String(search || ''));
      return params.get(ACTION_APPROVAL_BUSINESS_PARAM) || params.get(BUSINESS_PARAM) || '';
    }
    catch (error) { return ''; }
  };

  // Full adresse: sti + foretak. `keepSearch` beholder ovrige parametre — brukes ved
  // forste synk, sa en invitasjonslenke ikke mister parameteren sin for porten har lest den.
  const urlForRoute = (route, options) => {
    const settings = options || {};
    const path = pathForRoute(route, settings.subPage);
    if (!path) return null;
    let params;
    try { params = new URLSearchParams(String(settings.keepSearch || '')); }
    catch (error) { params = new URLSearchParams(); }
    params.delete(BUSINESS_PARAM);
    if (settings.businessId) params.set(BUSINESS_PARAM, settings.businessId);
    const query = params.toString();
    return query ? path + '?' + query : path;
  };

  // A voucher has its own transaction detail route. The query identifies the
  // voucher and financial year so the deep link also works in a new window.
  const VOUCHER_PARAM = 'bilag';
  const YEAR_PARAM = 'ar';

  const urlForVoucher = (voucherId, options) => {
    const settings = options || {};
    const id = String(voucherId || '').trim();
    const base = id ? urlForRoute('transaksjon', { businessId: settings.businessId }) : null;
    if (!base) return null;
    const cut = base.indexOf('?');
    const path = cut === -1 ? base : base.slice(0, cut);
    const params = new URLSearchParams(cut === -1 ? '' : base.slice(cut + 1));
    params.set(VOUCHER_PARAM, id);
    if (settings.year) params.set(YEAR_PARAM, String(settings.year));
    return path + '?' + params.toString();
  };

  const voucherFocusFromSearch = (search) => {
    let params;
    try { params = new URLSearchParams(String(search || '')); }
    catch (error) { return null; }
    const voucherId = String(params.get(VOUCHER_PARAM) || '').trim();
    if (!voucherId) return null;
    const year = Number(params.get(YEAR_PARAM));
    return { voucherId, year: Number.isFinite(year) && year > 0 ? year : null };
  };

  const voucherListFocusFromLocation = (locationLike) => {
    const location = locationLike || {};
    return routeForPath(location.pathname) === 'allebilag' ? voucherFocusFromSearch(location.search) : null;
  };

  // A help article opened inline on the Support > Articles page. The id is the
  // key of `helpArticles()`; the path says which page, the query says which article.
  const ARTICLE_PARAM = 'artikkel';

  const supportArticleSearch = (articleId) => {
    const id = String(articleId || '').trim();
    return id ? new URLSearchParams({ [ARTICLE_PARAM]: id }).toString() : '';
  };

  const urlForSupportArticle = (articleId, options) => urlForRoute('support', {
    subPage: 'articles',
    businessId: (options || {}).businessId,
    keepSearch: supportArticleSearch(articleId),
  });

  const supportArticleFromSearch = (search) => {
    try { return String(new URLSearchParams(String(search || '')).get(ARTICLE_PARAM) || '').trim(); }
    catch (error) { return ''; }
  };

  const samePath = (a, b) => normalizePath(a) === normalizePath(b);

  const searchOf = (url) => {
    const at = String(url == null ? '' : url).indexOf('?');
    return at === -1 ? '' : String(url).slice(at + 1).split('#')[0];
  };

  const sameUrl = (a, b) => samePath(a, b) && searchOf(a) === searchOf(b);

  const isYearClosingChecklistReturn = (fromRoute, toRoute) =>
    String(toRoute || '') === 'arsavslutning' && String(fromRoute || '').startsWith('arsavslutning-');
  const markYearClosingChecklistReturn = (fromRoute, toRoute) => {
    const requested = isYearClosingChecklistReturn(fromRoute, toRoute);
    if (requested) global.__plummeOpenYearClosingChecklist = true;
    return requested;
  };
  const consumeYearClosingChecklistReturn = () => {
    const requested = Boolean(global.__plummeOpenYearClosingChecklist);
    global.__plummeOpenYearClosingChecklist = false;
    return requested;
  };

  // Et klikk med modifikator, eller midtklikk, skal gjore det nettleseren lover:
  // apne i ny fane eller nytt vindu. Da skal appen la vare og ikke kalle preventDefault.
  const isModifiedClick = (event) => Boolean(
    event && (
      event.defaultPrevented
      || (typeof event.button === 'number' && event.button !== 0)
      || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
    ),
  );

  global.PlummeAppRoute = {
    ROUTE_PATHS,
    SUBPAGE_PATHS,
    BUSINESS_PARAM,
    ACTION_APPROVAL_BUSINESS_PARAM,
    pathForRoute,
    resolvePath,
    routeForPath,
    subPageForPath,
    subPagesForRoute,
    businessFromSearch,
    urlForRoute,
    urlForVoucher,
    voucherFocusFromSearch,
    voucherListFocusFromLocation,
    ARTICLE_PARAM,
    supportArticleSearch,
    urlForSupportArticle,
    supportArticleFromSearch,
    normalizePath,
    samePath,
    sameUrl,
    isYearClosingChecklistReturn,
    markYearClosingChecklistReturn,
    consumeYearClosingChecklistReturn,
    isModifiedClick,
  };
})(typeof window !== 'undefined' ? window : globalThis);
